import { useMutation, useQueryClient } from "@tanstack/react-query";
import mixpanel from "mixpanel-browser";
import { queryService } from "../services/query-service";
import { QueryKeys } from "../config/query-keys";
import { CreateConversationResponse } from "../models/api-types";
import useAuthStore from "@/store/use-auth-store";
import { useLLMSelection } from "@/features/llm-selection";

export function useCreateConversation() {
  const queryClient = useQueryClient();
  const { user } = useAuthStore();
  const { selectedModel } = useLLMSelection();

  const mutation = useMutation({
    mutationFn: ({
      platform,
      initialMessage,
      isTemporary,
      module,
      agentId,
    }: {
      platform: string;
      initialMessage?: string;
      isTemporary?: boolean;
      /** Konuşmanın modülü (dock'tan açıldıysa); sunucuda saklanır. */
      module?: string;
      /** Modülün ajanı; backend create DTO'suna ekleyince kayda geçer. */
      agentId?: string;
    }) =>
      queryService.createConversation(
        platform,
        initialMessage,
        isTemporary,
        module,
        agentId
      ),
    onSuccess: (response: CreateConversationResponse, variables) => {
      // 📊 chat_started event'ini Mixpanel'e gönder (her yeni chat'te bir kez)
      try {
        mixpanel.track("chat_started", {
          conversation_id: response?.data?._id,
          is_temporary: variables.isTemporary ?? false,
          module: variables.module ?? null,
          model_id: selectedModel?._id,
          model_name: selectedModel?.name,
        });
      } catch (e) {
        console.warn("Mixpanel error:", e);
      }

      // 🔄 Conversations list'i invalidate et ki yeni conversation görünsün
      queryClient.invalidateQueries({
        queryKey: [...QueryKeys.CONVERSATIONS.list, user?._id],
      });
    },
    onError: (error) => {
      console.error("Create conversation error:", error);
    },
  });

  return {
    createConversation: mutation.mutateAsync,
    isCreating: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
}
